
import { RouterModule_encodeParts, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { singleton as singleton_1, filter as filter_1, head, tail, choose, isEmpty, map as map_1, empty as empty_1, toArray, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { join, interpolate, toText, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { OnTableRowClick$1, CellContent, ColumnDefinition$1 } from "../../Widgets/Table/Types.js";
import { TableContainer } from "../../Widgets/Container.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Map_Location from "../../../public/assets/icons/Map_Location.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { stringHash, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { canAssignTrackers, canManageTelematicsConnection, canSeeAllTrackers, usePermissions } from "../../UserPermissions.js";
import { removeTracker, useTrackers } from "../../Requests/Telematics.js";
import { FormState__startLoading, FormState_get_empty } from "../../Shared/Shared.js";
import { AssignTrackerModalSheet } from "../AssignTrackerModal.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { toast } from "react-hot-toast";
import { ErrorAlert, WarningAlert } from "../../Components/Alert.js";
import { Button } from "../../Components/Button.js";
import { Skeleton } from "../../Components/Skeleton.js";

function testId(id) {
    return ["data-test-id", id];
}

function openInventory(tracker) {
    const matchValue = tracker.Assignment;
    if (matchValue == null) {
    }
    else {
        const assignment = matchValue;
        if (assignment.EntityType.tag === 1) {
            RouterModule_nav(ofArray(["sets", assignment.EntityId]), 1, 1);
        }
        else {
            RouterModule_nav(ofArray(["tools", assignment.EntityId]), 1, 1);
        }
    }
}

function identifierText(tracker) {
    return defaultArg(map((serial) => concat(tracker.Imei, " · ", ...serial), tracker.VendorSerial), tracker.Imei);
}

function statusText(t, tracker) {
    if (tracker.Disabled) {
        return t("telematics.trackers.status_disabled");
    }
    else if (tracker.Online) {
        return t("telematics.trackers.status_online");
    }
    else {
        return t("telematics.trackers.status_offline");
    }
}

function positionText(t, translateInterpreted, tracker) {
    let matchValue_1;
    const matchValue = tracker.Position;
    if (matchValue != null) {
        const position = matchValue;
        return toText(interpolate("%.5f%P(), %.5f%P() · %P()%P()", [position.Latitude, position.Longitude, (matchValue_1 = position.Fix, (matchValue_1 === "fix") ? t("telematics.trackers.fix_fix") : ((matchValue_1 === "stale") ? t("telematics.trackers.fix_stale") : t("telematics.trackers.fix_none"))), defaultArg(map((meters) => ((" (" + translateInterpreted("telematics.trackers.accuracy", {
            meters: meters,
        })) + ")"), position.AccuracyMeters), "")]));
    }
    else {
        return t("telematics.trackers.no_position");
    }
}

function assignmentTypeText(t, tracker) {
    const matchValue = tracker.Assignment;
    if (matchValue != null) {
        const assignment = matchValue;
        if (assignment.EntityType.tag === 1) {
            return t("general.set");
        }
        else {
            return t("general.tool");
        }
    }
    else {
        return t("telematics.trackers.not_assigned");
    }
}

function inventoryText(tracker) {
    return defaultArg(map((assignment) => assignment.EntityName, tracker.Assignment), "");
}

function inventoryNumberText(tracker) {
    return defaultArg(map((assignment) => assignment.EntityInventoryNumber, tracker.Assignment), "");
}

function TrackerTable(props) {
    let ColumnDefinitions, TableRows, Options;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const column = (id, header, filter, columnType, accessor) => (new ColumnDefinition$1(id, "", header, accessor, filter, columnType));
    return createElement(TableContainer, {
        Content: createElement(Table, (ColumnDefinitions = [column("name", t("general.name"), "text", "text", (tracker) => (new CellContent(0, [tracker.Name]))), column("identifier", t("telematics.trackers.identifier"), "text", "text", (tracker_1) => (new CellContent(0, [identifierText(tracker_1)]))), column("status", t("general.status"), "select", "text", (tracker_2) => (new CellContent(0, [statusText(t, tracker_2)]))), column("lastSeen", t("telematics.trackers.last_seen"), "dateRange", "dateTime", (tracker_3) => (new CellContent(9, [tracker_3.LastSeenAt]))), column("position", t("telematics.trackers.position"), "text", "text", (tracker_4) => (new CellContent(0, [positionText(t, (key, values) => (patternInput[1].t(key, values)), tracker_4)]))), column("battery", t("telematics.trackers.battery"), "select", "text", (tracker_5) => {
            const matchValue = tracker_5.BatteryLow;
            let matchResult;
            if (matchValue != null) {
                if (matchValue) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new CellContent(0, [t("telematics.trackers.battery_low")]);
                default:
                    return new CellContent(0, [""]);
            }
        }), column("assignment", t("telematics.trackers.assignment"), "select", "text", (tracker_6) => (new CellContent(0, [assignmentTypeText(t, tracker_6)]))), column("inventory", t("telematics.trackers.inventory"), "text", "text", (tracker_7) => (new CellContent(0, [inventoryText(tracker_7)]))), column("inventoryNumber", t("general.inventory_number"), "text", "text", (tracker_8) => (new CellContent(0, [inventoryNumberText(tracker_8)])))], (TableRows = toArray(props.Trackers), (Options = {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: true,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(0, [(tracker_9) => {
                openInventory(tracker_9);
            }]),
            RowSelection: props.CanAssign ? "multiRow" : "disabled",
            SaveTableConfiguration: false,
        }, {
            ColumnDefinitions: ColumnDefinitions,
            Controls: toList(delay(() => (props.CanAssign ? append(singleton(new TableControl$1(t("telematics.assignment.assign"), Map_Location(), props.OnAssign, true, true, "trackers-assign-control")), delay(() => singleton(new TableControl$1(t("telematics.assignment.remove"), Recycle_Bin_1(), props.OnRemove, true, false, "trackers-remove-control")))) : empty()))),
            Options: Options,
            TableKey: "tracker-overview",
            TableRows: TableRows,
        })))),
    });
}

function EmptyState(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "text-sm", "text-gray-600"])], testId(props.TestId), (elems = toList(delay(() => append(singleton(reactElement("span", {
        children: props.Text,
    })), delay(() => {
        const matchValue = props.Link;
        if (matchValue == null) {
            return singleton(defaultOf());
        }
        else {
            const label = matchValue[0];
            const href = matchValue[1];
            return singleton(reactElement("a", createObj(ofArray([["className", join(" ", ["underline", "text-primary"])], ["href", href], testId(concat(props.TestId, ..."-link")), ["children", label]]))));
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function TrackersOverview() {
    let Text$, elems_2, elems_1, elems;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const permissions = usePermissions();
    const canSeeAll = canSeeAllTrackers(permissions);
    const canManageConnection = canManageTelematicsConnection(permissions);
    const canAssign = canAssignTrackers(permissions);
    const data = useTrackers();
    const patternInput_1 = reactApi.useState(undefined);
    const setAssigning = patternInput_1[1];
    const patternInput_2 = reactApi.useState(empty_1());
    const setRemoving = patternInput_2[1];
    const removing = patternInput_2[0];
    let patternInput_3;
    const initial_2 = FormState_get_empty();
    patternInput_3 = reactApi.useState(initial_2);
    const setFormState = patternInput_3[1];
    const formState = patternInput_3[0];
    const matchValue_1 = data.data;
    if (matchValue_1 != null) {
        if (!matchValue_1.Connected) {
            const page_1 = matchValue_1;
            return createElement(EmptyState, (Text$ = t("telematics.trackers.no_connection"), {
                Link: unwrap(canManageConnection ? [t("telematics.trackers.no_connection_link"), RouterModule_encodeParts(ofArray(["settings", "permissions"]), 1)] : undefined),
                TestId: "trackers-no-connection",
                Text: Text$,
            }));
        }
        else {
            const page_2 = matchValue_1;
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], testId("trackers-overview"), (elems_2 = toList(delay(() => {
                let matchValue_2;
                return append((matchValue_2 = patternInput_1[0], (matchValue_2 == null) ? singleton(defaultOf()) : singleton(createElement(AssignTrackerModalSheet, {
                    OnAssigned: () => {
                        data.mutate();
                    },
                    OnClose: () => {
                        setAssigning(undefined);
                    },
                    Tracker: matchValue_2,
                }))), delay(() => {
                    let Title, arg_1, tracker_7;
                    return append(singleton(createElement(ConfirmationDialog, (Title = t("telematics.assignment.remove_confirmation_title"), {
                        Description: (arg_1 = ((tracker_7 = join(", ", map_1((tracker_6) => tracker_6.Name, removing)), {
                            inventory: join(", ", List_distinct(map_1(inventoryText, removing), {
                                Equals: (x_1, y) => (x_1 === y),
                                GetHashCode: (x_1) => (stringHash(x_1) | 0),
                            })),
                            tracker: tracker_7,
                        })), patternInput[1].t("telematics.assignment.remove_confirmation_description", arg_1)),
                        FormState: formState,
                        IsOpen: !isEmpty(removing),
                        OnClose: () => {
                            if (!formState.IsLoading) {
                                setRemoving(empty_1());
                            }
                        },
                        OnConfirm: () => {
                            if (!formState.IsLoading) {
                                setFormState(FormState__startLoading(formState));
                                let pr_4;
                                let pr_3;
                                const pr_2 = map_1((tupledArg) => {
                                    const assignment_1 = tupledArg[1];
                                    let pr_1;
                                    const pr = removeTracker(assignment_1.EntityType, assignment_1.EntityId, tupledArg[0].TrackerId);
                                    pr_1 = (pr.then((response) => {
                                        if (response.tag === 1) {
                                            return false;
                                        }
                                        else {
                                            return true;
                                        }
                                    }));
                                    return pr_1.then(void 0, ((_arg) => false));
                                }, choose((tracker_3) => map((assignment) => [tracker_3, assignment], tracker_3.Assignment), removing));
                                pr_3 = (Promise.all(pr_2));
                                pr_4 = (pr_3.then((results) => {
                                    setFormState(FormState_get_empty());
                                    setRemoving(empty_1());
                                    if (results.some((x) => x)) {
                                        toast.success(t("telematics.assignment.removed_toast"));
                                    }
                                    if (results.some((value) => !value)) {
                                        toast.error(t("telematics.assignment.remove_failed"));
                                    }
                                    data.mutate();
                                }));
                                pr_4.then();
                            }
                        },
                        Title: Title,
                    }))), delay(() => append((data.error != null) ? singleton(createElement(WarningAlert, {
                        Label: t("telematics.trackers.provider_error"),
                    })) : empty(), delay(() => (isEmpty(page_2.Trackers) ? singleton(createElement(EmptyState, {
                        TestId: "trackers-empty",
                        Text: canSeeAll ? t("telematics.trackers.no_trackers") : t("telematics.trackers.no_own_trackers"),
                    })) : singleton(createElement(TrackerTable, {
                        CanAssign: canAssign,
                        OnAssign: (trackers) => {
                            let matchResult, tracker_1;
                            if (!isEmpty(trackers)) {
                                if (isEmpty(tail(trackers))) {
                                    if (head(trackers).Assignment == null) {
                                        matchResult = 0;
                                        tracker_1 = head(trackers);
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 2;
                                }
                            }
                            else {
                                matchResult = 2;
                            }
                            switch (matchResult) {
                                case 0: {
                                    setAssigning(tracker_1);
                                    break;
                                }
                                case 1: {
                                    toast.error(t("telematics.tracker_already_assigned"));
                                    break;
                                }
                                case 2: {
                                    break;
                                }
                            }
                        },
                        OnRemove: (trackers_1) => {
                            const matchValue = filter_1((tracker_2) => (tracker_2.Assignment != null), trackers_1);
                            if (isEmpty(matchValue)) {
                                toast.error(t("telematics.assignment.nothing_to_remove"));
                            }
                            else {
                                setRemoving(matchValue);
                            }
                        },
                        Trackers: page_2.Trackers,
                    })))))));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        }
    }
    else if (data.error != null) {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], testId("trackers-load-failed"), (elems_1 = [createElement(ErrorAlert, {
            Label: t("telematics.trackers.load_failed"),
        }), reactElement("div", createObj(singleton_1((elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("telematics.trackers.reload"),
            OnClick: () => {
                data.mutate();
            },
            TestId: "trackers-reload-button",
            Variant: "secondary",
        })], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
    else {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
}

